import OverViewIcon from '../Icons/OverViewIcon';
import { Outlet } from 'react-router-dom';
//@ts-ignore
import { DashboardLayout as DashboardLayoutService } from '@careinfo/layout';
//@ts-ignore
import { tw } from '@careinfo/tailwind';
import RunsheetIcon from '../Icons/RunsheetIcon';
import InvoiceIcon from '../Icons/InvoiceIcon';
import ContactSVG from '../Icons/svgComponent/ContactSVG';
import EmailCampaignSVG from '../Icons/svgComponent/EmailCampaignSVG';
import QuickSmsSVG from '../Icons/svgComponent/QuickSmsSVG';
import SmsCampaingSVG from '../Icons/svgComponent/SmsCampaingSVG';
import BillingSVG from '../Icons/svgComponent/BillingSVG';
import DashboardSVG from '../Icons/svgComponent/DashboardSVG';
import { HistoryIcon, SettingsIcon } from 'lucide-react';

export const navigation: any = [
  {
    name: 'Dashboard',
    href: '',
    icon: '',
    children: [
      {
        name: 'Overview',
        href: '/email-sms-marketing',
        icon: DashboardSVG,
        activeIcon: OverViewIcon,
      },
    ],
  },
  {
    name: 'Marketing',
    href: '',
    icon: '',
    children: [
      {
        name: 'Contacts',
        href: '/email-sms-marketing/contact',
        icon: ContactSVG,
        activeIcon: RunsheetIcon,
      },
      {
        name: 'Quick Email',
        href: '/email-sms-marketing/quick-email',
        icon: EmailCampaignSVG,
        activeIcon: RunsheetIcon,
      },
      {
        name: 'Email Campaign',
        href: '/email-sms-marketing/email-campaign',
        icon: EmailCampaignSVG,
        activeIcon: RunsheetIcon,
      },
      {
        name: 'Quick SMS',
         href: '/email-sms-marketing/quick-sms',
        icon: QuickSmsSVG,
        activeIcon: RunsheetIcon,
      },
      {
        name: 'SMS Campaign',
        href: '/email-sms-marketing/sms-campaign',
        icon: SmsCampaingSVG,
        activeIcon: RunsheetIcon,
      },
      // {
      //   name: 'Billing',
      //   href: '/email-sms-marketing/billing',
      //   icon: BillingSVG,
      //   activeIcon: RunsheetIcon,
      // },
      {
        name: 'History',
        href: '/email-sms-marketing/history',
         icon: HistoryIcon,
        activeIcon: RunsheetIcon,
      },
      {
        name: 'Settings',
        href: '/email-sms-marketing/settings',
         icon: SettingsIcon,
        activeIcon: RunsheetIcon,
      },
    ],
  },
  // {
  //   name: 'Finance',
  //   href: '',
  //   icon: '',
  //   children: [
  //     {
  //       name: 'Invoice',
  //       href: '/invoice',
  //       icon: InvoiceIcon,
  //       activeIcon: InvoiceIcon,
  //     },
  //   ],
  // },
];

const DashboardLayout = () => {
  return (
    <DashboardLayoutService navigation={navigation}>
      <div className={tw` p-2 h-full`}>
        <Outlet />
      </div>
    </DashboardLayoutService>
  );
};

export default DashboardLayout;
